import type { IToggle } from '@unleash/proxy-client-react'

/**
 * Build an Unleash bootstrap toggle. The app assembles its own bootstrap arrays
 * with this helper and passes them to `FlagProvider`. Bootstrap values are what
 * the client serves before it reaches the server and while it is unreachable,
 * so set each one to its flag's safe default.
 */
export const toggle = (name: string, enabled: boolean): IToggle => ({
  name,
  enabled,
  variant: { name: 'disabled', enabled: false },
  impressionData: false
})
